import { useTranslation } from 'react-i18next';

import {
  CreateAppointment,
  CreateAppointmentResponse,
} from 'models/Appointment';

import { AppointmentInfoProps } from 'hooks/useSchedule';
import { useStorage } from 'hooks/useStorage';

import dayjs from 'utils/dayjs';
import { axiosFactory } from 'utils/http/axiosFactory';

export const currentAppointmentStorageKey = 'currentAppointmentId';

interface CreateAppointmentParams {
  partnerId: string;
  authorization: string;
  sessionId?: string;
}

export const useCreateAppointment = () => {
  const { i18n } = useTranslation();
  const { set } = useStorage();

  const createAppointment = async (
    data: AppointmentInfoProps,
    { authorization, sessionId }: CreateAppointmentParams,
  ) => {
    const fetch = axiosFactory(i18n.language, 'attendence');

    const {
      patient: {
        birthdate = '',
        surname = '',
        name = '',
        description = '',
        biologicalSex,
      },
      quantity,
      address,
      productId,
      doctorId = '',
      searchId = '',
      appointmentTime,
      startDate,
      reason,
      productSlug,
    } = data;

    const createAppointment: CreateAppointment = {
      patient: {
        birthdate,
        surname,
        name,
        description,
        biologicalSex,
      },
      address,
      product: {
        id: productId,
        quantity,
        response: reason,
        slug: productSlug,
      },
      professionalId: doctorId,
      lang: i18n.language,
      endTime: appointmentTime?.endTime ?? '',
      startDate: dayjs(startDate).format('DD/MM/YYYY'),
      startTime: appointmentTime?.startTime ?? '',
      searchId,
      sessionId,
    };

    const response = await fetch.post<CreateAppointmentResponse>(
      '/appointment',
      createAppointment,
      {
        headers: {
          Authorization: authorization,
        },
      },
    );

    set(currentAppointmentStorageKey, response.data.appointment.appointmentId);

    return {
      appointmentId: response.data.appointment.appointmentId,
      payment: response.data.payment,
    };
  };

  return { createAppointment };
};
